<template lang="html">

  <VqModal
    :name="modalName">
    <template v-slot:header>
      <h2 class="modal-title">{{ $t('components.modalOpenTicket.title') }}</h2>
      <button
        type="button"
        class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
        v-on:click="close">
        <span class="css-icon is-close"></span>
      </button>
    </template>
    <template v-slot:content>
      <div class="forms">
        <form>
          <div class="container has-separator">
            <div class="row">
              <VqInput
                :label="$t('components.modalOpenTicket.form.subject')"
                classes="col-tab-12"
                name="subject"
                type="text"
                :errors="errors.subject"
                v-model="formData.subject"
              />
            </div>
            <div class="row">
              <VqTextarea
                :label="$t('components.modalOpenTicket.form.body')"
                classes="col-tab-12"
                name="body"
                :errors="errors.body"
                v-model="formData.body"
              />
            </div>
          </div>
        </form>
      </div>
    </template>
    <template v-slot:footer>
      <button type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.modalOpenTicket.form.cancel') }}</button>
      <div>
        <button
        v-if="$store.state.display_edit && $store.state.otrs_is_active"
        type="button"
        class="button is-small is-gamma"
        :class="{'is-loading': loading}"
        @click="submit">{{ $t('components.modalOpenTicket.form.submit') }}</button>
      </div>
    </template>
  </VqModal>

</template>

<script lang="js">

import { eventHubMixin } from '@/mixins/event';

import SUPPORT from '@/api/support';

import VqModal from '@/components/VqModal.vue';
import VqInput from '@/components/VqInput.vue';
import VqTextarea from '@/components/VqTextarea.vue';

export default {
  name: 'ModalOpenTicket',
  mixins: [eventHubMixin],
  components: {
    VqModal,
    VqInput,
    VqTextarea,
  },
  props: [],

  data() {
    return {
      modalName: 'open-ticket',
      formData: {
        subject: '',
        body: '',
      },
      errors: {},
      loading: false
    };
  },
  mounted() {
    this.eventHub.$on(`modal:${this.modalName}:open`, (data) => {
      this.initFormData()
      this.initFormErrors()
    });
  },
  methods: {
    close() {
      this.emitCloseModal(this.modalName)
    },

    initFormData() {
      this.formData = {
        subject: '',
        body: '',
      };
    },

    initFormErrors() {
      this.errors = {
        subject: [],
        body: [],
      };
    },

    displayToaster(data) {
      const toaster = {
        title: this.$t('components.modalOpenTicket.toasts.title'),
        state: 'success',
        id: 1,
        text: this.$t('components.modalOpenTicket.toasts.content'),
        // link: 'https://dev-portal.telecloud.fr'
      };
      this.emitAddToaster(toaster);
    },

    submit() {
      this.loading = true
      SUPPORT.create(this.formData).then(
        (res) => {
          this.initFormData()
          this.initFormErrors()
          this.close()
          this.loading = false
          this.displayToaster(res.data)
        },
        (err) => {
          Object.assign(this.errors, err.response.data)
        },
      );
    },
  },
};
</script>
